const isEmpty = (val: string | undefined | number | null) => {
  return val === null || val === '-' || val === undefined;
};
/**
 * 判断是否有标记
 * @param data  数据列表
 * @param item  当前数据
 * @param currentIndex 当前数据值下标
 * @param valueFunc  获取真实数据所在属性的方法
 * @returns
 */
export function getSeriesSymbol(
  data: Array<any>,
  item: any,
  currentIndex: number,
  valueFunc = (value: number) => value,
) {
  const prev = valueFunc(data[currentIndex - 1]);
  const current = valueFunc(item);
  const next = valueFunc(data[currentIndex + 1]);

  let opacity = 0;
  if (isEmpty(prev) && isEmpty(next) && !isEmpty(current)) {
    opacity = 1;
  }

  return {
    value: current,
    opacity,
  };
}

export function dealwithLineSymbol(data: Array<any>) {
  return data?.map((item: any, index: number) => {
    const isObject = typeof item === 'object';
    const { value, opacity } = getSeriesSymbol(
      data,
      item,
      index,
      (itemData: any) => {
        // console.log(itemData, '-----------');
        return isObject ? itemData?.value : itemData;
      },
    );
    // 有部分内容需要在这里绑定了特殊数据，比如gameStore页面的byRegion在这里存放了reviews
    const itemObj = typeof item === 'object' ? item : {};
    return {
      ...itemObj,
      value,
      itemStyle: {
        opacity,
        ...(item?.itemStyle || {}),
      },
    };
  });
}
